var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRecruiters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5123 13.2047L12.8463 13.5901C12.5374 13.7689 12.3472 14.0987 12.3472 14.4556V24.2676C12.3472 25.0374 13.1805 25.5186 13.8472 25.1336L22.3389 20.2307C22.6483 20.0521 22.8389 19.722 22.8389 19.3647V9.55313C22.8389 8.78338 22.0056 8.30225 21.339 8.68706L13.5123 13.2047Z",
    fill: "#706D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9135 3.20065C14.5796 2.81593 14.5801 1.85463 13.9144 1.46926L11.8766 0.289614C11.567 0.11043 11.1854 0.110203 10.8756 0.289018L2.0924 5.35946C1.42592 5.74421 1.42562 6.70609 2.09187 7.09125L4.13325 8.27138C4.44278 8.45032 4.82429 8.45039 5.13389 8.27158L13.9135 3.20065Z",
    fill: "#706D9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6454 7.0969C21.3138 6.71044 21.3107 5.74441 20.6398 5.36225L18.0026 3.86006C17.6939 3.68424 17.3151 3.68537 17.0075 3.86305L7.32615 9.45476C7.06686 9.60452 7.07557 9.9817 7.3415 10.1193L10.8766 12.161C11.1859 12.3396 11.5669 12.3397 11.8763 12.1614L15.3896 10.1355L20.6454 7.0969Z",
    fill: "#706D9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91203 12.8221C5.91203 13.4776 5.21859 13.9009 4.63564 13.6012L4.50509 13.5341C4.18325 13.3687 3.98091 13.0372 3.98091 12.6754V10.7573C3.98091 10.3997 3.7899 10.0692 3.47996 9.89076L1.49904 8.74999C0.832378 8.36607 0 8.84726 0 9.61657V19.3438C0 19.7011 0.190579 20.0312 0.499954 20.2098L8.91614 25.0695C9.5828 25.4545 10.4162 24.9733 10.4162 24.2035V14.4792C10.4162 14.1216 10.2252 13.7912 9.91534 13.6127L7.22524 12.0631C6.64126 11.7267 5.91203 12.1482 5.91203 12.8221Z",
    fill: "#706D9D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruiters);
export default __webpack_public_path__ + "static/media/recruiters.c74a33f93138dc78c3fe5849b359544f.svg";
export { ForwardRef as ReactComponent };